import { create } from 'zustand';

const initialSessionState = {
  user: null,
  loaded: false,
  error: undefined,
};

const useSessionStore = create((set) => ({
  ...initialSessionState,

  setUser: (user) => set({ user }),
  setLoaded: (loaded) => set({ loaded }),
  setError: (error) => set({ error }),
}));

export default useSessionStore;
